// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1bB8y","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3N7k7"};